export default function createPurchaseEvent(result) {
    return {
        event: 'purchase',
        eventCategory: `OPC - ${result.analytics.isHeatingSet ? 'hs ' : ''}${result.analytics.productVersion || 'unknown'}`,
        eventLabel: 'OPC - purchase',
        purchaseData: {
            giftCard: '',
            orderType: 'Sales_order',
            shippingMethod: result.shippingMethod === 'store'
                ? `IQOS - ${result.analytics.pickupName}`
                : `Indirect chain ${result.analytics.pickupName}`,
        },
        ecommerce: {
            purchase: {
                actionField: {
                    id: result.orderId,
                    revenue: result.total / 100,
                    affiliation: 'LV',
                    tax: result.tax / 100,
                    shipping: result.deliveryPrice / 100,
                    coupon: result.coupon || '',
                },
                products: [
                    {
                        name: result.analytics.name,
                        id: result.product.variantCode,
                        price: result.unitPrice / 100,
                        brand: 'IQOS',
                        category: result.analytics.category,
                        variant: result.analytics.color,
                        quantity: 1,
                        dimension51: '',
                        dimension52: 'In Stock',
                        dimension54: '',
                        dimension55: '',
                        metric11: result.originalUnitPrice / 100,
                    },
                ],
            },
        },
    };
}
